var t = new Date();
var weekDay = t.getDay();
var currentHour = t.getHours();
if (weekDay  === 5 && currentHour >= 17 ) {
  storePickupSettings.min_days = 2;
}

// This is not used right now as long as the switch from below is active
if (weekDay  === 6 && currentHour >= 11 ) {
  storePickupSettings.min_days = 2;
}
switch (weekDay) {
  case 6:
    console.log('Saturday');
    storePickupSettings.min_days = 1;
  break;
}
// continuosly check if the fields are completed
document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
  
    disableCheckoutButton2();
    var tt = setInterval(function(){
      disableCheckoutButton2();
      //console.log('check.............')
      var fieldsCorrect = checkPickupFields();
      //console.log({fieldsCorrect})
      if (fieldsCorrect === true) {
        //clearInterval(tt);  
      }
      
    }, 1000);
    //setTimeout(function() { clearInterval(tt); }, 5000);  

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	//console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  jqCR(document).on('change', '#pickup-selected-store', function(){checkPickupFields()})  
  trackChange(jqCR("#pickup-selected-store")[0] );  

   jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
   trackChange(jqCR("#note-pickup-date")[0] );
});


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (pickupDate) {
      activateCheckoutButton2();
      return true;
    }
    disableCheckoutButton2()
    return false;
}

function activateCheckoutButton2(){
  //console.log('Activate')
      document.querySelector('#checkout').disabled = false;
  }

function disableCheckoutButton2(){    
    document.querySelector('#checkout').disabled = true;
}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate, selectedMonth);
  //if (selectedDay  === 6) {
  if (weekDay  === 6 && selectedDay  === 6) {  
    timepicker.set('min',[12, 0]); 
    timepicker.set('max',[12, 0]);
  }

  if (weekDay === 5 && selectedDay === 6) {  
    //timepicker.set('min',[12, 0]); 
    timepicker.set('max',[11, 30]);
  }

  if(selectedDate.getDate() === 24 && selectedMonth === 11 && selectedDate.getFullYear() === 2025) {
  	//timepicker.set('disable',[{ from: [11, 00], to: [11, 00] }]); 
		timepicker.set('min',[10, 0]); 
    timepicker.set('max',[12, 0]);
  }
}
